'use client';
import ImageGallery from "@/components/common/image-gallery";
import { PostContentFallback, useLoadPostBySlug } from "@/components/common/posts/posts.provider";
import { SimilarPosts } from "@/components/common/posts/similar-posts";
import SectionPage from "@/components/common/section-page";

export default function PostPage() {
    const { currentPost, postsBasePath } = useLoadPostBySlug("initiative-cacao");

    return (
                <PostContentFallback>
        <article>
            {currentPost && (
                <div style={{backgroundImage: `url(${currentPost.image})`}} className={"h-[400px] w-full bg-cover bg-center relative"}
                >
                    <div className={"bg-bleu-marine h-[100px] w-full flex items-center justify-start absolute bottom-0"}
                    >
                        <SectionPage sectionType={"2xl"}
                        >
                            <h1 className={"text-white text-4xl font-exo"}>{currentPost.title}</h1>
                        </SectionPage>
                    </div>
                </div>
            )}

            <SectionPage sectionType={"xl"} className={"my-12"}>
                <div className="markdown-content text-gray-800">
                    <h1 className="text-3xl font-bold font-exo text-rose mt-8 mb-4">Promotion du chocolat en Afrique : le Directeur Général de Côte d’Ivoire Tourisme en faveur d’gune synergie d’actions entre pays producteurs</h1>


                    <p className="my-4 text-normal leading-relaxed">
                        La 1ère édition du <strong>World Chocolate Initiative Competition</strong> s’est déroulée du 02 au 05 novembre 2023 au Bushman Café à Abidjan.
                        Pour Madame Malékah Mourad-Condé, Directeur Général de Côte d’Ivoire Tourisme, la Côte d’Ivoire et le Ghana doivent élaborer ensemble un plan stratégique en vue de la production locale du chocolat.
                        Le tourisme durable et équitable permet d’éliminer la pauvreté en milieu rural , a-t-elle ajouté.
                    </p>

                    <p className="my-4 text-normal leading-relaxed">
                    Pour Madame Malékah MOURAD-CONDE, cette rencontre vise à sensibiliser les acteurs du transport en vue d’une amélioration continue de la qualité de leurs services afin de mieux répondre aux attentes des touristes internes et externes.
                    </p>

                    <p className="my-4 text-normal leading-relaxed">
                    Une initiative que salue l’Organisation des Transporteurs représentée par son Directeur Général Adjoint, M. Salif SAMAKE.
                    </p>
                </div>


                <div className={'mt-8'}>
                    <ImageGallery images={
                        Array.from({ length: 3 }).map((_, index) => ({
                                src: `/images${postsBasePath}/${String(currentPost?.slug)}/gallerie/${index + 1}.png`,
                            alt: `image${index + 1}`,
                            width: 700,
                            height: 700,
                        }))
                    } aspectRatio={"video"} gridClassName={"grid grid-cols-1 md:grid-cols-3 gap-4"} />
                </div>

                                    {currentPost && <SimilarPosts currentSlug={currentPost.slug} />}
                
            </SectionPage>
        </article>
                </PostContentFallback>
        
    );
}
